import clsx from 'clsx'
import Image from 'next/image'
import NextLink from 'next/link'

import { Link } from '@wartek-id/link'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

import { Card } from 'app/KinerjaShared/components/Card'
import { assetUrl } from 'utils/url'
import { PANDUAN_PENGELOLAAN_URL } from 'app/KinerjaShared/utils/panduan'

import type { FC } from 'react'

type CardProgressPenilaianTahunanProps = {
  isAvailable?: boolean
  year: number
  targetUrl: string
}

const CardProgressPenilaianTahunan: FC<CardProgressPenilaianTahunanProps> = ({
  isAvailable = false,
  year,
  targetUrl,
}) => {
  return (
    <Card
      className={clsx(
        // Handle container
        '!rounded !m-0',
        {
          '!bg-[linear-gradient(91.11deg,_#103178_48.06%,_#2560E0_137.64%)]':
            isAvailable,
          '!bg-surface-disabled': !isAvailable,
        },

        // Handle content
        '!flex !flex-row items-center gap-6 p-6 relative overflow-hidden'
      )}
    >
      <img
        alt=""
        role="presentation"
        src={assetUrl('/images/pengelolaan-kinerja/confetti.png')}
        width={144}
        className={clsx(
          'absolute right-0 top-0 select-none pointer-events-none',
          { grayscale: !isAvailable }
        )}
      />

      <div className="flex-none">
        <Image
          alt=""
          src="/illustrations/img-reflection-documents-magnifying-glass.png"
          width={84}
          height={84}
          className={clsx('select-none pointer-events-none', {
            grayscale: !isAvailable,
          })}
        />
      </div>

      <div className="flex-1">
        <div className="flex flex-col gap-1 justify-center">
          {isAvailable ? (
            <>
              <Text
                variant="subheading"
                color="inverse"
                className="!uppercase tracking-[0.5px]"
              >
                Hasil Penilaian Kinerja Kepala Sekolah
              </Text>

              <Text variant="heading-lg" color="inverse">
                Predikat Kinerja Tahun {year}
              </Text>
            </>
          ) : (
            <>
              <Text variant="heading-lg" color="disabled">
                Predikat Kinerja Tahun {year} belum tersedia
              </Text>

              <Text variant="body" color="disabled">
                Nanti akan muncul di sini jika sudah tersedia.{' '}
                <NextLink href={PANDUAN_PENGELOLAAN_URL} passHref>
                  <Link
                    tabIndex={0}
                    underline
                    className="!px-0"
                    target="_blank"
                  >
                    Info selengkapnya
                  </Link>
                </NextLink>
                .
              </Text>
            </>
          )}
        </div>
      </div>

      <div className="flex-none z-10">
        {isAvailable && (
          <NextLink href={targetUrl} passHref>
            <Button
              as="a"
              color="white"
              size="lg"
              className="w-60 !text-interactive-default"
            >
              Cek
            </Button>
          </NextLink>
        )}
      </div>
    </Card>
  )
}
export default CardProgressPenilaianTahunan
